import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import { Badge} from 'reactstrap';
import Dropdown from 'react-dropdown'

class PresetModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sharingMode: false,
            usersInGuilds: [],
            usersToShare: [],
            shareToAll: false,
        }
    }

    async onClickShare() {
        this.setState({
            sharingMode: true
        });
    }

    executeShare() {
        if (this.state.shareToAll) {
            this.props.ethereum.guilds.sharePresetWithAllGuilds(
                this.props.preset.id);
        } else {
           for (let i in this.state.usersToShare) {
                let userId = this.state.usersToShare[i].userId;
                let presetId = this.props.preset.id;
                this.props.presets.sharePreset(
                    presetId, userId);
            }
        }

        this.clear();
        this.props.onClose();
    }

    clear() {
        this.setState({
            sharingMode: false,
            usersToShare: [],
            usersInGuilds: [],
            shareToAll: false,
        });
    }

    onSelectUser(user) {
        this.setState({usersToShare: this.state.usersToShare.concat([user])});
    }

    getUserOptions() {
        let options = [];
        for (let i in this.state.usersInGuilds) {
            let user = this.state.usersInGuilds[i];
            options.push({label: user.userName, value: user});
        }

        return options;
    }

    onClickNo() {
        this.clear();
        this.props.onClose();
    }

    onShareToAllCheckbox(val) {
        this.setState({shareToAll: !this.state.shareToAll});
    }

    render() {
        let name = this.props.preset !== undefined ? this.props.preset.name : '';
        if (this.state.sharingMode) {
            return (
                <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.props.onClose}>
              <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Dropdown
                    className=''
                    options={this.getUserOptions()}
                    onChange={(o) => this.onSelectUser(o.value)}
                    value={undefined}
                    placeholder="Share with users" />

                  {this.state.usersToShare.map(user => <Badge>{user.userName}</Badge>)}
                    <form>
                    <div className="refined-checkbox-preferences">
                      <label>
                        <input 
                               type="checkbox"
                               value="share"
                               checked={this.state.shareToAll}
                               onChange={(e) => this.onShareToAllCheckbox(e.target.value)} />
                    Share with all guild members
                      </label>
                    </div>
              </form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => this.executeShare()}>
                  Yes
                </Button>
                    <Button variant="primary" onClick={() => this.onClickNo()}>
                  No
                </Button>
              </Modal.Footer>
            </Modal>
            );
        }
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.props.onClose}>
              <Modal.Header closeButton>
                <Modal.Title>{name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>Do you want to replace this project's LFOs with this preset's LFOs?</Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.props.onClickYes}>
                  Yes
                </Button>
                <Button variant="primary" onClick={this.props.onClickNo}>
                  No
                </Button>
                <Button variant="primary" onClick={() => this.onClickShare()}>
                  Share
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}

export default PresetModal;
